import type { AgentDoc } from "@albertine/types";
import type { AgentPickerItem } from "./AgentPicker";

type Agent = AgentDoc & { id: string };

/**
 * Agents a member can be assigned to, with the current agent first. A disabled agent
 * stays in the list while they are the assignee, so the picker can still show them.
 */
export function toAssignableAgents(
    agents: Agent[],
    currentAgentId: string | undefined,
    assignedAgentId?: string | null,
): AgentPickerItem[] {
    const assignable = agents.filter(
        (agent) =>
            (agent.role === "agent" || agent.id === currentAgentId) &&
            (!agent.disabled || agent.id === assignedAgentId),
    );
    const current = assignable.find((agent) => agent.id === currentAgentId);
    const rest = assignable.filter((agent) => agent.id !== currentAgentId);
    const ordered = current ? [current, ...rest] : rest;

    return ordered.map((agent) => ({
        id: agent.id,
        name: agent.name,
        firstName: agent.firstName,
    }));
}
